import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';

import { ScrollPanel } from 'primereact/scrollpanel';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import Recaptcha from 'react-recaptcha';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
class NuevoRegistro extends Component {
    constructor() {
        super();
        this.state = {
            usuarioRegistro: {},
            errores: {},
            mostrarModalRegistro: false,
            verificaCapchap:false

        }
        this.mostrarModalRegistro = this.mostrarModalRegistro.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.registrarUsuario = this.registrarUsuario.bind(this);
        this.recaptchaLoad = this.recaptchaLoad.bind(this);
        this.verificaCapchaCorrecto = this.verificaCapchaCorrecto.bind(this);
        this.validarUsuario = this.validarUsuario.bind(this);
    }
    mostrarModalRegistro() {
        this.setState({
            mostrarModalRegistro: true

        });
    }
    cerrarModal() {
        this.setState({
            mostrarModalRegistro: false
        });
        
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }
    recaptchaLoad(){
        console.log("captchap");
    }
    verificaCapchaCorrecto(response){
     if(response){
        this.setState({
            verificaCapchap: true
        });
     }
    }

    validarFormulario = (usuario) => {
        const errores = {};
        var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
 var validacionCorreo = expreReg.exec(usuario.correo);
        if (!usuario.usuario)
            errores.usuario = "El usuario es requerido";
        if (!usuario.nombre)
            errores.nombre = "El nombre es requerido";
        if (!usuario.correo)
            errores.correo = "El correo es requerido";
            if(!validacionCorreo)
            errores.correo = "El correo no es valido";
        return errores;
    }
    validarUsuario(){
        const { usuarioRegistro} = this.state;
        servicioUsuario.buscarUsuarioNombre(usuarioRegistro).then(response => {
           
            if(response.data===true){
                this.setState({ usuarioRegistro: {}});
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'El usuario ya existe' });
            }
         

        }).catch(error => {
           
        });

    }
    registrarUsuario() {



        const { usuarioRegistro, verificaCapchap } = this.state;

        const validacion = this.validarFormulario(usuarioRegistro);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            if(verificaCapchap===true){
            servicioUsuario.nuevoRegistroUsuario(usuarioRegistro).then(response => {
                this.setState({ usuarioRegistro: {}, mostrarModalRegistro: false });
                this.growl.show({ severity: 'success', summary: 'Exito', detail: 'Se envio usuario y contraseña a su correo' });

            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se creo el usuario' });
            });
        }
        }

    }
    render() {
        const { usuarioRegistro, errores } = this.state;
        return (
            <div><h1><a onClick={this.mostrarModalRegistro}>Registrar</a></h1>
             <Growl ref={(el) => this.growl = el} />
                <Dialog header="Nuevo Registro" visible={this.state.mostrarModalRegistro} style={{ width: '30vw' }} onHide={(e) => this.setState({ mostrarModalRegistro: false })} maximizable>
                    <ScrollPanel style={{ width: '100%', height: '450px' }}>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-12">
                                <h4>Usuario:</h4>
                                <InputText id="usuario" name="usuarioRegistro.usuario" onBlur={this.validarUsuario} value={usuarioRegistro.usuario || ''} className={errores.usuario ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
                                {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-12">
                                <h4>Nombre:</h4>
                                <InputText id="nombre" name="usuarioRegistro.nombre" value={usuarioRegistro.nombre || ''} className={errores.nombre ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
                                {errores.nombre ? <div> <Message severity="error" text={errores.nombre} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-12">
                                <h4>Correo:</h4>
                                <InputText id="correo" name="usuarioRegistro.correo" value={usuarioRegistro.correo || ''} className={errores.correo ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
                                {errores.correo ? <div> <Message severity="error" text={errores.correo} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-12">
                            <Recaptcha sitekey="6LePa7UUAAAAABwcnOacAhKLhiTzPWZ8MT-ya6Ok" render="explicit" onloadCallback={this.recaptchaLoad} verifyCallback={this.verificaCapchaCorrecto}/>
                            </div>
                        </div>

                        <br />
                        <div className="p-grid" style={{ width: "100%" }}>
                            <div className="p-col"></div>
                            <div className="p-col"></div>
                            <div className="p-col ">
                                <Button label="Aceptar" onClick={this.registrarUsuario} icon="pi pi-check" />
                            </div>
                            <div className="p-col">
                                <Button label="Cancelar" onClick={this.cerrarModal} icon="pi pi-times" className="p-button-danger" />
                            </div>
                        </div>
                    </ScrollPanel>
                </Dialog>

            </div>
        );
    }
}
export default NuevoRegistro;